import axios from 'axios';
import axiosRetry from 'axios-retry';
import router from '@/router';
import { useUserStore } from '../stores/userStore';

const api = axios.create({
  host: '127.0.0.1',
  port: '8000',
  withCredentials: false,
  timeout: 5000,
});

axiosRetry(api, {
  retries: 5,
  retryCondition: (error) => axiosRetry.isNetworkError(error) || error.code === 'ECONNABORTED',
  retryDelay: axiosRetry.exponentialDelay,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers = config.headers || {};
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

const isDestructiveReauthRequest = (config) => {
  const url = config?.url || '';
  if (url.includes('/user/wipe')) return true;
  const method = (config?.method || '').toLowerCase();
  return method === 'delete' && url.endsWith('/api/user');
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const userStore = useUserStore();
    const status = error.response?.status;
    const config = error.config || {};

    // 401 на re-auth эндпоинтах (wipe/delete) означает неверный пароль,
    // а не истёкшую сессию — не разлогиниваем и не редиректим.
    if (status === 401 && isDestructiveReauthRequest(config)) {
      const msg = error.response?.data?.error;
      if (msg) globalThis.$toast?.showToast(msg, 'danger');
      return Promise.reject(error);
    }

    switch (status) {
      case 401:
        userStore.logout?.();
        router.push('/login');
        break;
      case 400:
        globalThis.$toast?.showToast('Bad request', 'danger');
        break;
      case 500:
        globalThis.$toast?.showToast('Internal Server Error', 'danger');
        break;
      default:
        globalThis.$toast?.showToast(status, 'warn');
        break;
    }
    return Promise.reject(error);
  },
);

export default api;
